import React, { useState, useEffect, useContext, useRef } from 'react';
import { TableContext } from '../context';
import { McTabBar } from "@maersk-global/mds-react-wrapper/components-core/mc-tab-bar";
import { McTab } from "@maersk-global/mds-react-wrapper/components-core/mc-tab";
import { GoPencil } from 'react-icons/go';
import { MdOutlineCancel } from 'react-icons/md';
import { Box, Typography, CircularProgress } from '@mui/material';
import { KeyboardArrowDown as KeyboardArrowDownIcon, KeyboardArrowUp as KeyboardArrowUpIcon } from '@mui/icons-material';
import LandingPageTable from './LandingPageTable';
import CiInfoDrawer from "./CiInfoDrawer";
import ChangeDetailsDrawer from "./ChangeDetailsDrawer";
import DeploymentDetailsDrawer from "./DeploymentDetailsDrawer";
import ChangesDrawer, { useChangesDrawer } from "./LandingPageComponents/ChangesDrawer";
import ApplicationsDrawer, { useApplicationsDrawer } from "./LandingPageComponents/ApplicationsDrawer";
import IncidentsDrawer, { useIncidentsDrawer } from "./LandingPageComponents/IncidentsDrawer";
import LandingPageInsights from "./LandingPageComponents/LandingPageInsights";
import { McTypeahead } from "@maersk-global/mds-react-wrapper/components-core/mc-typeahead";
import axios from 'axios';
// Define the Maersk font family
const maerskFontFamily = '"Maersk Text", -apple-system, BlinkMacSystemFont, "Microsoft JhengHei", "Microsoft Yahei", "微软雅黑", STXihei, "华文细黑", sans-serif';

/**
 * LandingPage component renders the landing page of the Flux Portal.
 * It includes a header with insights cards, user search, and a table displaying change summaries.
 */
const LandingPage = () => {
  const {
    graphData,
    tokenFetched,
    getToken,
  } = useContext(TableContext);

  // State for search functionality
  const [inputNameValue, setInputNameValue] = useState("");
  const [inputNameValue1, setInputNameValue1] = useState("");
  const [suggestions, setSuggestions] = useState(null);
  const [suggestionClicked, setSuggestionClicked] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [edit, setEdit] = useState(true);
  const [spinnerDisplay, setSpinnerDisplay] = useState(false);
  const [isClearing, setIsClearing] = useState(false);
  
  // State for chart data
  const [successRate, setSuccessRate] = useState({ success: 0, failure: 0, ongoing: 0, total: 0 });
  const [overdueChanges, setOverdueChanges] = useState({ overdue: 0, total: 0 });
  const [conflictingChanges, setConflictingChanges] = useState({ conflicts: 0, total: 0 });
  const [incidentsData, setIncidentsData] = useState({ p1:0, p2: 0, p3: 0, p4: 0, total: 0 });

  // State for user details
  const [userDetails, setUserDetails] = useState({
    applications: [],
    platforms: [],
    portfolios: [],
    applicationsCount: 0,
    platformsCount: 0,
    portfoliosCount: 0
  });

  // State for API data
  const [apiData, setApiData] = useState(null);

  // State for table data
  const [tableDataForDisplay, setTableDataForDisplay] = useState([]);

  // State for tabs and view selection
  const [viewType, setViewType] = useState("applications"); // applications, platforms, or portfolios
  const [selectedPlatform, setSelectedPlatform] = useState("");
  const [selectedPortfolio, setSelectedPortfolio] = useState("");
  const [timeFilter, setTimeFilter] = useState("ongoing"); // ongoing, past, future
  const [isLoadingData, setIsLoadingData] = useState(true);
  const [timeFilterDropdownOpen, setTimeFilterDropdownOpen] = useState(false);
  const [platformDropdownOpen, setPlatformDropdownOpen] = useState(false);
  const [portfolioDropdownOpen, setPortfolioDropdownOpen] = useState(false);
  const timeFilterDropdownRef = useRef(null);
  const platformDropdownRef = useRef(null);
  const portfolioDropdownRef = useRef(null);

  // Drawer states
  const [isdrawerOpen, setisdrawerOpen] = useState(false);
  const [drawerCi, setDrawerCi] = useState("");
  const [drawerCiCategory, setDrawerCiCategory] = useState("");
  const [drawerType, setDrawerType] = useState("ci_info");
  const [drawerChange, setDrawerChange] = useState("");
  
  // Applications drawer states
  const [isApplicationsDrawerOpen, setIsApplicationsDrawerOpen] = useState(false);
  const [applicationsDrawerContent, setApplicationsDrawerContent] = useState([]);
  const [applicationsDrawerHeading, setApplicationsDrawerHeading] = useState("");

  // Changes drawer states
  const [isChangesDrawerOpen, setIsChangesDrawerOpen] = useState(false);
  
  // Original change states for the changes drawer (no longer needed for change details)
  const [originalChangesContent, setOriginalChangesContent] = useState(null);
  const [originalChangesHeading, setOriginalChangesHeading] = useState("");
  const [originalChangeType, setOriginalChangeType] = useState("");
  const [isLoadingPlatformData, setIsLoadingPlatformData] = useState(false);
  const [isLoadingPortfolioData, setIsLoadingPortfolioData] = useState(false);
  const tabLabels = ["SNOW Changes", "CI/CD Changes"];

  // Changes drawer states for content
  const [changesDrawerContent, setChangesDrawerContent] = useState([]);
  const [changesDrawerHeading, setChangesDrawerHeading] = useState("");

  // Incidents drawer states
  const [isIncidentsDrawerOpen, setIsIncidentsDrawerOpen] = useState(false);
  const [incidentsDrawerContent, setIncidentsDrawerContent] = useState([]);
  const [incidentsDrawerHeading, setIncidentsDrawerHeading] = useState("");



    
  // Helper function to update chart and table data based on current selections
  const updateDisplayData = (data = apiData, currentViewType = viewType, currentTimeFilter = timeFilter, platformName = selectedPlatform, portfolioName = selectedPortfolio) => {
    if (!data) return;

    console.log('updateDisplayData called with:', { 
      currentViewType, 
      currentTimeFilter, 
      platformName, 
      portfolioName,
      availablePlatforms: data.platform_changes ? Object.keys(data.platform_changes) : 'No platform_changes'
    });

    let changesData;
    
    if (currentViewType === "applications") {
      changesData = data.application_changes;
    } else if (currentViewType === "platforms") {
      if (isLoadingPlatformData) {
        // Show loading state in charts and tables
        setSuccessRate({ success: 0, failure: 0, ongoing: 0, total: 0 });
        setOverdueChanges({ overdue: 0, total: 0 });
        setConflictingChanges({ conflicts: 0, total: 0 });
        setIncidentsData({ p1: 0, p2: 0, p3: 0, p4: 0, total: 0 });
        setTableDataForDisplay([]);
        return;
      }

      // Platform changes are now organized by platform name
      if (data.platform_changes) {
        changesData = data.platform_changes[platformName];
        
        if (!changesData) {
          console.log('No data found for platform:', platformName);
          console.log('Available platform change keys:', Object.keys(data.platform_changes));
          
          // Try to find platform that contains the name or vice versa
          const matchingKey = Object.keys(data.platform_changes).find(key => 
            key.includes(platformName) || platformName.includes(key)
          );
          
          if (matchingKey) {
            console.log('Found partial match:', matchingKey);
            changesData = data.platform_changes[matchingKey];
          } else {
            // If no matching platform is found, changesData remains null
            // This will result in showing empty state for the user's platform
            console.log('No platform data available for user platform:', platformName);
            changesData = null;
          }
        }
      }
      console.log('Platform changes data for', platformName, ':', changesData);
    } else if (currentViewType === "portfolios") {
      if (isLoadingPortfolioData) {
        // Show loading state in charts and tables
        setSuccessRate({ success: 0, failure: 0, ongoing: 0, total: 0 });
        setOverdueChanges({ overdue: 0, total: 0 });
        setConflictingChanges({ conflicts: 0, total: 0 });
        setIncidentsData({ p1: 0, p2: 0, p3: 0, p4: 0, total: 0 });
        setTableDataForDisplay([]);
        return;
      }

      if (data.portfolio_changes) {
        // console.log('Portfolio data available:', data.portfolio_changes);
        
        if (portfolioName && data.portfolio_changes[portfolioName]) {
          // Use specific portfolio data if available
          // console.log('Using specific portfolio data for:', portfolioName);
          changesData = data.portfolio_changes[portfolioName];
        } else {
          // Fall back to top-level portfolio changes
          // console.log('Using top-level portfolio data');
          changesData = data.portfolio_changes;
        }
        
        console.log('Selected changes data:', changesData);
        
        if (!changesData) {
          console.log('No data found for portfolio:', portfolioName);
          setSuccessRate({ success: 0, failure: 0, ongoing: 0, total: 0 });
          setOverdueChanges({ overdue: 0, total: 0 });
          setConflictingChanges({ conflicts: 0, total: 0 });
          setTableDataForDisplay([]);
          return;
        }
      }
    } else {
      return;
    }

    if (!changesData) {
      console.log('No changes data found for current selection');
      console.log('Falling back to empty data structure');
      // Reset all chart data to zero when no changes data is found
      setSuccessRate({ success: 0, failure: 0, ongoing: 0, total: 0 });
      setOverdueChanges({ overdue: 0, total: 0 });
      setConflictingChanges({ conflicts: 0, total: 0 });
      setIncidentsData({ p1: 0, p2: 0, p3: 0, p4: 0, total: 0 });
      setTableDataForDisplay([]);
      return;
    }

    console.log('Changes data found:', changesData);

    // Always update chart data - use defaults if data doesn't exist
    const successCount = changesData.success_status?.successful_changes?.count || 0;
    const failureCount = changesData.success_status?.failed_changes?.count || 0;
    const ongoingCount = changesData.success_status?.ongoing_status_changes?.count || 0;
    setSuccessRate({
      success: successCount,
      failure: failureCount,
      ongoing: ongoingCount,
      total: successCount + failureCount + ongoingCount
    });

    const overdueCount = changesData.overdue_changes?.count || 0;
    setOverdueChanges({
      overdue: overdueCount,
      total: overdueCount
    });

    // For conflicting changes, we'll need to check if this field exists in the new format
    // For now, using a default structure
    const conflictsCount = changesData.conflicting_changes?.conflict_groups?.length || 0;
    setConflictingChanges({
      conflicts: conflictsCount,
      total: conflictsCount
    });

    // Update incidents data based on current view type
    let incidentsInfo;
    if (currentViewType === "applications") {
      incidentsInfo = data.application_incidents;
    } else if (currentViewType === "platforms") {
      incidentsInfo = data.platform_incidents;
    } else if (currentViewType === "portfolios") {
      incidentsInfo = data.portfolio_incidents;
    }

    if (incidentsInfo) {
      const p1Count = incidentsInfo.p1_incidents?.length || 0;
      const p2Count = incidentsInfo.p2_incidents?.length || 0;
      const p3Count = incidentsInfo.p3_incidents?.length || 0;
      const p4Count = incidentsInfo.p4_incidents?.length || 0;
      setIncidentsData({
        p1: p1Count,
        p2: p2Count,
        p3: p3Count,
        p4: p4Count,
        total: p1Count + p2Count + p3Count + p4Count
      });
    } else {
      setIncidentsData({ p1: 0, p2: 0, p3: 0, p4: 0, total: 0 });
    }

    // Update table data based on current time filter
    let tableChanges = [];
    if (currentTimeFilter === "past") {
      tableChanges = changesData.past_changes || [];
    } else if (currentTimeFilter === "ongoing") {
      tableChanges = changesData.ongoing_changes || [];
    } else if (currentTimeFilter === "future") {
      tableChanges = changesData.future_changes || [];
    }

    // Transform the data to match the expected format for the table
    const transformedTableData = tableChanges.map(change => {
      // Create the base object with all required fields
      const transformedItem = {
        "Change Number": change.change_number || 'N/A',
        "Configuration Item": change.configuration_item || 'N/A',
        "Risk": change.risk_impact || 'N/A',
        "Short Description": change.short_description || 'N/A',
        "Planned Start Date": change.planned_start_date || 'N/A',
        "Planned End Date": change.planned_end_date || 'N/A',
        "State": change.state || 'N/A',
        "Type": change.type || 'N/A',
        "Assignment Group": change.assignment_group || 'N/A',
        "Requested By": change.requested_by || 'N/A',
        "Close Code": change.close_code || 'N/A',
        "Category": change.change_type || 'N/A'
      };
      
      // Add relation field only if it exists
      if (change.relation) {
        transformedItem["Relation"] = `${change.relation}`;
      }
      
      return transformedItem;
    }).filter(change => change["Change Number"] !== 'N/A'); // Filter out rows with no change number

    console.log('Raw table changes:', tableChanges);
    console.log('Transformed table data:', transformedTableData);

    // Update the table data state
    setTableDataForDisplay(transformedTableData);
  };

  // Colors for charts
  const COLORS = ["#003E62", "#42B0D5", "#A1D1E8", "#E2F3FB"];

  // Dummy card data
  const successRateData = [
    { label: "Success", value: successRate.success },
    { label: "Failure", value: successRate.failure },
    { label: "In Progress", value: successRate.ongoing }
  ];

  const overdueData = [
    { label: "Overdue", value: overdueChanges.overdue }
  ];

  const conflictData = [
    { label: "Conflicts", value: conflictingChanges.conflicts }
  ];

  const incidentsChartData = [
    { label: "P1", value: incidentsData.p1},
    { label: "P2", value: incidentsData.p2 },
    { label: "P3", value: incidentsData.p3 },
    { label: "P4", value: incidentsData.p4 }
  ];

  // API call functions
  const getUserDetails = async (userName, userEmail) => {
    setIsLoadingData(true);
    try {
      // Prepare request body for POST request
      const requestBody = {
        user_name: userName,
        user_email: userEmail
      };
      
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/landing_page/get_user_details`,
        requestBody,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("jwt_token"),
          }
        }
      );
      
      if (response.status === 200) {
        const data = response.data.data;
        
        // Store the API data
        setApiData(data);
        
        // Update user details
        setUserDetails({
          applications: data.applications || [],
          platforms: data.platform || [],
          portfolios: data.portfolio || [],
          applicationsCount: data.applications?.length || 0,
          platformsCount: data.platform?.length || 0,
          portfoliosCount: data.portfolio?.length || 0
        });
        
        console.log('User details updated:', {
          applications: data.applications || [],
          applicationsCount: data.applications?.length || 0,
          platforms: data.platform || [],
          portfolios: data.portfolio || []
        });

        // Check if applications is empty and auto-switch to platforms
        const hasApplications = data.applications && data.applications.length > 0;
        const hasPlatforms = data.platform && data.platform.length > 0;
        const hasPortfolios = data.portfolio && data.portfolio.length > 0;
        
        let currentViewType = viewType;
        
        // Auto-switch logic: if applications is empty, switch to platforms, if platforms is also empty, switch to portfolios
        if (!hasApplications && hasPlatforms && viewType === "applications") {
          currentViewType = "platforms";
          setViewType("platforms");
          console.log('Auto-switching to platforms view because applications is empty');
        } else if (!hasApplications && !hasPlatforms && hasPortfolios && viewType === "applications") {
          currentViewType = "portfolios";
          setViewType("portfolios");
          console.log('Auto-switching to portfolios view because both applications and platforms are empty');
        }

        // Set default platform and portfolio to first available ones if not already set
        const defaultPlatform = data.platform?.[0] || "";
        const defaultPortfolio = data.portfolio?.[0] || "";
        
        console.log('Available platforms from user:', data.platform);
        console.log('Available platform changes keys:', data.platform_changes ? Object.keys(data.platform_changes) : 'No platform_changes');
        
        // Always update to the first available platform/portfolio for new user searches
        // or set defaults on initial load when selections are empty
        if (defaultPlatform) {
          setSelectedPlatform(defaultPlatform);
        }
        if (defaultPortfolio) {
          setSelectedPortfolio(defaultPortfolio);
        }

        // Update display data with the newly set selections
        updateDisplayData(data, currentViewType, timeFilter, defaultPlatform, defaultPortfolio);
      } else {
        throw new Error(`API returned status: ${response.status}`);
      }
    } catch (error) {
      console.error('Error fetching user details:', error);
      // Initialize with empty data structure on error
      setUserDetails({
        applications: [],
        platforms: [],
        portfolios: [],
        applicationsCount: 0,
        platformsCount: 0,
        portfoliosCount: 0
      });
      setApiData(null);
      // Reset chart data to zeros
      setSuccessRate({ success: 0, failure: 0, ongoing: 0, total: 0 });
      setOverdueChanges({ overdue: 0, total: 0 });
      setConflictingChanges({ conflicts: 0, total: 0 });
      setIncidentsData({ p1: 0, p2: 0, p3: 0, p4: 0, total: 0 });
    } finally {
      setIsLoadingData(false);
    }
  };

  const fetchUserData = async (userName) => {
    try {
      if (!userName || userName.length < 2) {
        setSuggestions(null);
       
        return;
      }

      
      const requestBody = {
        user_name: userName
      };

      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/landing_page/user_name_suggestions`,
        requestBody,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: "Bearer " + localStorage.getItem("jwt_token"),
          }
        }
      );
      
      if (response.status !== 200) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const apiResponse = response.data;

      if (apiResponse.status === 200) {
        // Transform the response to match the expected format
        // const transformedSuggestions = apiResponse.data.map(user => ({
        //   displayName: user.name,
        //   email: user.email,
        //   userName: user.user_name,
        //   sysId: user.sys_id
        // }));
        setSuggestions(apiResponse.data || []);
      } else {
        setSuggestions([]);
      }
    } catch (error) {
      console.error('Error fetching user suggestions:', error);
      setSuggestions(null);
    }
  };

const fetchSinglePortfolioData = async (portfolioName) => {
  const requestBody = {
    portfolio: portfolioName
  };

  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BACKEND_URI}/api/landing_page/single_portfolio_change`,
      requestBody,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: "Bearer " + localStorage.getItem("jwt_token"),
        }
      }
    );

    if (response.status !== 200) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const result = response.data;
    console.log('Portfolio API response:', result);

    if (!result?.data) {
      throw new Error("Missing data field in response");
    }

    return result;

  } catch (error) {
    console.error("Error fetching portfolio data:", error);
    return null;
  }
};

const fetchSinglePlatformData = async (platformName) => {
  const requestBody = {
    platform: platformName
  };

  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BACKEND_URI}/api/landing_page/single_platform_change`,
      requestBody,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: "Bearer " + localStorage.getItem("jwt_token"),
        }
      }
    );

    if (response.status !== 200) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const result = response.data;

    if (!result?.data) {
      throw new Error("Missing data field in response");
    }

    return {
      data: result.data,
      platform_incidents: result.platform_incidents
    };

  } catch (error) {
    console.error("Error fetching platform data:", error);
    return null;
  }
};



  // Load initial data when component mounts
  useEffect(() => {
    if (graphData?.displayName && graphData?.mail && tokenFetched) {
      console.log('Loading initial data for user:', graphData.displayName);
      getUserDetails(graphData.displayName, graphData.mail);
    }
  }, [tokenFetched]);

  // Debounced input change effect
  // useEffect(() => {
  //   const timeoutId = setTimeout(() => {
  //     if (inputNameValue.length >= 2 && !suggestionClicked) {
  //       fetchUserData(inputNameValue);
  //     } else if (inputNameValue.length < 2) {
  //       setSuggestions(null);
  //     }
  //   }, 500); // 500ms debounce

  //   return () => clearTimeout(timeoutId);
  // }, [inputNameValue, suggestionClicked]);

  // Debug effect to track state changes
  useEffect(() => {
    console.log('LandingPage state update:', {
      viewType,
      timeFilter,
      selectedPlatform,
      selectedPortfolio,
      tableDataLength: tableDataForDisplay?.length || 0,
      isLoadingData
    });
  }, [viewType, timeFilter, selectedPlatform, selectedPortfolio, tableDataForDisplay, isLoadingData]);

  // Debug effect to track drawer state changes
  useEffect(() => {
    console.log('Drawer state changed:', {
      isApplicationsDrawerOpen,
      applicationsDrawerHeading,
      applicationsDrawerContentLength: applicationsDrawerContent?.length || 0,
      applicationsDrawerContent
    });
  }, [isApplicationsDrawerOpen, applicationsDrawerHeading, applicationsDrawerContent]);

  // Handle clicks outside dropdowns
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (timeFilterDropdownRef.current && !timeFilterDropdownRef.current.contains(event.target)) {
        setTimeFilterDropdownOpen(false);
      }
      if (platformDropdownRef.current && !platformDropdownRef.current.contains(event.target)) {
        setPlatformDropdownOpen(false);
      }
      if (portfolioDropdownRef.current && !portfolioDropdownRef.current.contains(event.target)) {
        setPortfolioDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // Handle input change for user search
  const handleInputChange = (e) => {
    const value = e.target.value;
    setInputNameValue(value);
    setSuggestionClicked(false);
    
    // Clear suggestions immediately if input is too short
    if (value.length < 2) {
      setSuggestions(null);
    }
    else{
      fetchUserData(value);
    }
  };

  // Handle suggestion click
  // const handleSuggestionClick = (user) => {
  //   setInputNameValue(user.label);
  //   setInputNameValue1(user.value);
  //   setSelectedUser(user);
  //   setSuggestions([]);
  //   setSuggestionClicked(true);
  //   setEdit(false);
    
  //   // Reset platform and portfolio selections for new user
  //   setSelectedPlatform("");
  //   setSelectedPortfolio("");
    
  //   // Fetch data for selected user using their display name and email
  //   // In the new format: label is displayName, value is email
  //   getUserDetails(user.label, user.value);
  // };

  // Handle view type change (applications/platforms/portfolios)
  const handleViewTypeChange = (newViewType) => {
    setViewType(newViewType);
    // Update display data with the new view type
    updateDisplayData(apiData, newViewType, timeFilter, selectedPlatform, selectedPortfolio);
  };

  // Handle platform selection
  const handlePlatformChange = async (platform) => {
    setSelectedPlatform(platform);
    setIsLoadingPlatformData(true);
    
    try {
      const result = await fetchSinglePlatformData(platform);
      if (result) {
        // Create the new data structure
        const newApiData = {
          ...apiData,
          platform_changes: {
            ...apiData.platform_changes,
            [platform]: result.data[platform]
          },
          platform_incidents: result.platform_incidents
        };
        // Update the apiData with new platform data
        setApiData(newApiData);
        
        // Update display data with the new platform data
        updateDisplayData(
          newApiData,
          viewType,
          timeFilter,
          platform,
          selectedPortfolio
        );
      }
    } catch (error) {
      console.error('Error fetching platform data:', error);
    } finally {
      setIsLoadingPlatformData(false);
    }
  };

  const handlePortfolioChange = async (portfolio) => {
    setSelectedPortfolio(portfolio);
    setIsLoadingPortfolioData(true);
    
    try {
      const result = await fetchSinglePortfolioData(portfolio);
      if (result && result.data) {
        console.log('Updating portfolio data:', portfolio, result.data);
        
        // Create the new data structure
        const newApiData = {
          ...apiData,
          portfolio_changes: {
            ...(apiData.portfolio_changes || {}),
            [portfolio]: result.data
          },
          portfolio_incidents: result.portfolio_incidents
        };
        
        // Update the apiData with new portfolio data
        setApiData(newApiData);
        
        // Update display data with the new portfolio data immediately
        updateDisplayData(
          newApiData,
          viewType,
          timeFilter,
          selectedPlatform,
          portfolio
        );
      }
    } catch (error) {
      console.error('Error fetching portfolio data:', error);
    } finally {
      setIsLoadingPortfolioData(false);
    }
  };

  // Handle time filter change
  const handleTimeFilterChange = (filter) => {
    setTimeFilter(filter);
    setTimeFilterDropdownOpen(false); // Close dropdown after selection
    // Update display data with the new time filter
    updateDisplayData(apiData, viewType, filter, selectedPlatform, selectedPortfolio);
  };

  // Handle dropdown toggle
  const handleTimeFilterDropdownToggle = () => {
    setTimeFilterDropdownOpen(!timeFilterDropdownOpen);
  };

  const handlePlatformDropdownToggle = () => {
    setPlatformDropdownOpen(!platformDropdownOpen);
  };

  const handlePortfolioDropdownToggle = () => {
    setPortfolioDropdownOpen(!portfolioDropdownOpen);
  };

  const handleApplicationsDrawerOpen = () => {   
    const result = generateApplicationsContent();
    
    if (result) {
      if (isApplicationsDrawerOpen) {
        setIsApplicationsDrawerOpen(false);
        setTimeout(() => {
          setApplicationsDrawerHeading(result.heading);
          setApplicationsDrawerContent(result.drawerContent);
          setIsApplicationsDrawerOpen(true);
        }, 100);
      } else {
        setApplicationsDrawerHeading(result.heading);
        setApplicationsDrawerContent(result.drawerContent);
        setIsApplicationsDrawerOpen(true);
      }
    }
  };

  const handleApplicationsDrawerClose = () => {
    setIsApplicationsDrawerOpen(false);
    setTimeout(() => {
      setApplicationsDrawerContent([]);
      setApplicationsDrawerHeading("");
      setSuggestions(null);
    }, 100);
  };

  const handleChangeNumberClick = (changeNumber) => {
    if (changeNumber) {
      // Open change details in a new tab
      const url = `/change_details?changeNumber=${encodeURIComponent(changeNumber)}`;
      window.open(url, '_blank');
    }
  };

  const handleChangesDrawerOpen = (changeType) => {
    if (!apiData) return;
    
    // Reset drawer state when opening
    setOriginalChangesContent(null);
    setOriginalChangesHeading("");
    setOriginalChangeType(changeType); // Store the change type

    // Generate content using the hook
    const result = generateChangesContent(changeType);
    
    if (result) {
      if (isChangesDrawerOpen) {
        setIsChangesDrawerOpen(false);
        setTimeout(() => {
          setChangesDrawerHeading(result.heading);
          setChangesDrawerContent(result.drawerContent);
          setIsChangesDrawerOpen(true);
        }, 100);
      } else {
        setChangesDrawerHeading(result.heading);
        setChangesDrawerContent(result.drawerContent);
        setIsChangesDrawerOpen(true);
      }
    }
  };

  const handleChangesDrawerClose = () => {
    setIsChangesDrawerOpen(false);
    // Reset drawer state
    setOriginalChangesContent(null);
    setOriginalChangesHeading("");
    setOriginalChangeType("");
    setTimeout(() => {
      setChangesDrawerContent([]);
      setChangesDrawerHeading("");
      setSuggestions(null);
    }, 100);
  };

  const handleIncidentsDrawerOpen = (incidentType) => {
    if (!apiData) return;
    
    // Generate content using the hook
    const result = generateIncidentsContent(incidentType);
    
    if (result) {
      if (isIncidentsDrawerOpen) {
        setIsIncidentsDrawerOpen(false);
        setTimeout(() => {
          setIncidentsDrawerHeading(result.heading);
          setIncidentsDrawerContent(result.drawerContent);
          setIsIncidentsDrawerOpen(true);
        }, 100);
      } else {
        setIncidentsDrawerHeading(result.heading);
        setIncidentsDrawerContent(result.drawerContent);
        setIsIncidentsDrawerOpen(true);
      }
    }
  };

  const handleIncidentsDrawerClose = () => {
    setIsIncidentsDrawerOpen(false);
    setTimeout(() => {
      setIncidentsDrawerContent([]);
      setIncidentsDrawerHeading("");
      setSuggestions(null);
    }, 100);
  };

  // Use the changes drawer hook
  const { handleChangesDrawerOpen: generateChangesContent } = useChangesDrawer(
    apiData,
    viewType,
    selectedPlatform,
    selectedPortfolio,
    handleChangeNumberClick
  );

  // Use the applications drawer hook
  const { handleApplicationsDrawerOpen: generateApplicationsContent } = useApplicationsDrawer(
    userDetails,
    edit,
    inputNameValue1
  );
  const ref = useRef(null);
  // Use the incidents drawer hook
  const { handleIncidentsDrawerOpen: generateIncidentsContent } = useIncidentsDrawer(
    apiData,
    viewType,
    selectedPlatform,
    selectedPortfolio
  );

useEffect(() => {
console.log('Input name value changed:', inputNameValue);
}, [inputNameValue])


  return (
    <div className="LandingPage1">
      {/* Applications Drawer */}
      <ApplicationsDrawer
        isApplicationsDrawerOpen={isApplicationsDrawerOpen}
        applicationsDrawerHeading={applicationsDrawerHeading}
        applicationsDrawerContent={applicationsDrawerContent}
        onClose={handleApplicationsDrawerClose}
      />

      {/* Changes Drawer */}
      <ChangesDrawer
        isChangesDrawerOpen={isChangesDrawerOpen}
        changesDrawerHeading={changesDrawerHeading}
        changesDrawerContent={changesDrawerContent}
        onClose={handleChangesDrawerClose}
        apiData={apiData}
        viewType={viewType}
        selectedPlatform={selectedPlatform}
        onChangeNumberClick={handleChangeNumberClick}
      />

      {/* Incidents Drawer */}
      <IncidentsDrawer
        isIncidentsDrawerOpen={isIncidentsDrawerOpen}
        incidentsDrawerHeading={incidentsDrawerHeading}
        incidentsDrawerContent={incidentsDrawerContent}
        onClose={handleIncidentsDrawerClose}
      />
      
      {/* Drawer Components */}
      {isdrawerOpen && (
        drawerType === "ci_info" ? (
          <CiInfoDrawer
            isdrawerOpen={isdrawerOpen}
            setisdrawerOpen={setisdrawerOpen}
            drawerCi={drawerCi}
            drawerCiCategory={drawerCiCategory}
          />
        ) : drawerType === "change_details" ? (
            <ChangeDetailsDrawer
              isdrawerOpen={isdrawerOpen}
              setisdrawerOpen={setisdrawerOpen}
              drawerCi={drawerCi}
              drawerCiCategory={drawerCiCategory}
              drawerChange={drawerChange}
            />
          ) : (
            <DeploymentDetailsDrawer
              isdrawerOpen={isdrawerOpen}
              setisdrawerOpen={setisdrawerOpen}
              drawerCi={drawerCi}
              drawerCiCategory={drawerCiCategory}
              drawerChange={drawerChange}
            />
          )
      )}
      
      <div className="content-lp-wrapper">
        <div className="content-lp">
          <div className="content-lp-item">
            {edit ? (
              <>
                <div className={`transition-heading`}>My Changes Overview</div>
                {!(isLoadingData || spinnerDisplay) && (
                  <span
                    style={{
                      marginLeft: "8px",
                      cursor: "pointer"
                    }}
                    onClick={() => {
                      setEdit(false);
                      // Focus the typeahead input after a brief delay to ensure it's rendered
                      setTimeout(() => {
                        if (ref.current) {
                          ref.current.focus();
                        }
                      }, 100);
                    }}
                  >
                    <GoPencil size={20} title="Search for other users" />
                  </span>
                )}
              </>
            ) : (
              <>
                {
                  <>
                    <div
                      style={{
                        width: "300px",
                        display: "inline-block",
                        position: "relative",
                        marginLeft: "20px"
                      }}
                    >
                   { <McTypeahead
                      ref={ref}
                      showlistonfocus={true}
                      maxoptions="20"
                      data={suggestions}
                      debounce="600"
                      autoFocus
                      label=""
                      placeholder='Search for other users'
                      hiddenlabel={true}
                      clearbutton={true}
                      name="username"
                      input={(e)=>setInputNameValue(e.target.value)}
                      focus={(e) => console.log("Focus event:", e)}
                      blur={(e) => console.log("Blur event:", e)}
                      click={(e) => console.log("Click event:", e)}
                      keypress={(e) => console.log("KeyPress event:", e.key)}
                      search={async (e)=>{

                        if(e.target.value.length< 3){
                          return;
                        }
                        // Check if ref is still valid before proceeding
                        if (!ref.current) {
                          console.log('Ref is null, skipping search');
                          return;
                        }
                        
                        // Skip search if we're in the middle of a clear operation
                        if (isClearing) {
                          console.log('Currently clearing, skipping search');
                          return;
                        }
                      
                        ref.current.innerHTML = "";
                        ref.current.loading = true;
                        
                        try {
                          await fetchUserData(e.target.value);
                        } catch (error) {
                          console.error('Error in fetchUserData:', error);
                        } finally {
                          // Always reset loading state if ref is still valid
                          if (ref.current) {
                            ref.current.loading = false;
                          }
                        }
                        
                        console.log('Input changed:', e.target.value);
                      }}
                      optionselected={async (e) => {
                        console.log('Option selected:', e.detail);
                        setTimeout(() => {
                          if (ref.current) {
                            ref.current.blur();
                            const inputElement = ref.current.querySelector('input');
                            if (inputElement) {
                              inputElement.blur();
                            }
                          }
                        }, 100);
                        setSuggestionClicked(true);
                        setInputNameValue(e.detail.label);
                        setEdit(false);
                        await getUserDetails(e.detail.label, e.detail.sublabel);
                        setSuggestions(null);
                      }}
                      
                      clearbuttonclick={async () => {
                        // Set clearing flag to prevent search events during clear operation
                        setIsClearing(true);
                        
                        setEdit(true);
                        setSpinnerDisplay(true);
                        setSuggestions(null);
                        setSuggestionClicked(false);
                        
                        try {
                          // Reset to user's own data
                          setSelectedUser(null);
                          if (graphData?.displayName && graphData?.mail) {
                            await getUserDetails(graphData.displayName, graphData.mail);
                          }
                        } catch (error) {
                          console.error("Error resetting to user data:", error);
                        } finally {
                          setSpinnerDisplay(false);
                          // Reset loading state if ref is still valid
                          if (ref.current) {
                            ref.current.loading = false;
                          }
                          // Reset clearing flag after a short delay to ensure all events are processed
                          setTimeout(() => {
                            setIsClearing(false);
                          }, 100);
                        }
                      }}
                      optionsheight="200px"
                      minchars="3"
                      keepclearbuttonvisible
                      matchlabelonly
                      hint="Type a min of 3 characters to search"
                    />
}
                  
                      {/* <div
                        id="suggestion-container-lp"
                        style={{
                          width: "100%",
                          maxHeight: "100px",
                          backgroundColor: "white",
                          zIndex: 10,
                          position: "absolute",
                          display: (suggestions.length > 0 || isLoadingSuggestions) && !suggestionClicked ? "block" : "none",
                          borderTopLeftRadius: "0px",
                          overflowY: "auto",
                          textAlign: "left",
                          border: '1px solid #ccc',
                          borderTop: 'none',
                          borderRadius: '0 0 5px 5px'
                        }}
                      >
                        {isLoadingSuggestions ? (
                          <div
                            style={{
                              padding: '10px',
                              color: '#999',
                              cursor: 'default',
                            }}
                          >
                            Loading...
                          </div>
                        ) : (
                          suggestions.map((user, index) => (
                            <div
                              key={index}
                              className="suggestion-item-lp"
                              onClick={() => handleSuggestionClick(user)}
                              style={{
                                padding: '10px',
                                cursor: 'pointer',
                                borderBottom: index < suggestions.length - 1 ? '1px solid #eee' : 'none'
                              }}
                            >
                              <strong>{user.displayName}</strong>
                              <br />
                              <small>{user.email}</small>
                            </div>
                          ))
                        )}
                      </div> */}
                    </div>
                    {/* <MdOutlineCancel
                      size={20}
                      style={{ marginLeft: "5px", cursor: "pointer" }}
                      onClick={async () => {
                        setEdit(true);
                        setSpinnerDisplay(true);
                        setInputNameValue("");
                        setInputNameValue1("");
                        setSuggestions([]);
                        setSuggestionClicked(false);
                        
                        try {
                          // Reset to user's own data
                          setSelectedUser(null);
                          if (graphData?.displayName && graphData?.mail) {
                            await getUserDetails(graphData.displayName, graphData.mail);
                          }
                        } catch (error) {
                          console.error("Error resetting to user data:", error);
                        } finally {
                          setSpinnerDisplay(false);
                        }
                      }}
                    /> */}
                  </>
                }
              </>
            )}
          </div>

          {/* Loading State */}
          {(isLoadingData || spinnerDisplay) ? (
            <div style={{ 
              display: 'flex', 
              justifyContent: 'center', 
              alignItems: 'center',
              marginTop: '50px'
            }}>
              <CircularProgress />
            </div>
          ) : (
            <>
              {/* View Type Tabs */}
              <div className="content-lp-item">
                <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'nowrap' }}>
                  <McTabBar 
                    tabchange={(e) => handleViewTypeChange(
                      e.detail === 0 ? "applications" : 
                      e.detail === 1 ? "platforms" : "portfolios"
                    )} 
                    currentindex={
                      viewType === "applications" ? 0 : 
                      viewType === "platforms" ? 1 : 2
                    }
                    style={{ flex: '1', minWidth: '0' }}
                  >
                    <McTab 
                      slot="tab" 
                      label={edit ? "My Applications" : "Applications"} 
                      active={viewType === "applications"}
                      style={{ display: 'inline-flex', alignItems: 'center', whiteSpace: 'nowrap' }}
                    >
                      <span slot="suffix" style={{ display: 'inline-flex', alignItems: 'center' }}>
                        <div
                          style={{ 
                            cursor: 'pointer', 
                            display: 'inline-flex',
                            alignItems: 'center',
                            padding: '2px',
                            borderRadius: '4px'
                          }}
                          onClick={(e) => {
                            console.log('Chip clicked!');
                            e.stopPropagation();
                            e.preventDefault();
                            handleApplicationsDrawerOpen();
                          }}
                          onMouseDown={(e) => {
                            e.stopPropagation();
                          }}
                        >
                          <mc-tag 
                            appearance="info" 
                            fit="small" 
                            label={userDetails.applicationsCount.toString()}
                          ></mc-tag>
                        </div>
                      </span>
                    </McTab>
                    <div slot="panel"></div>
                    <McTab 
                      slot="tab" 
                      label={edit ? "My Platform" : "Platform"} 
                      active={viewType === "platforms"}
                      style={{ whiteSpace: 'nowrap' }}
                    ></McTab>
                    <div slot="panel"></div>
                    <McTab 
                      slot="tab" 
                      label={edit ? "My Portfolio" : "Portfolio"} 
                      active={viewType === "portfolios"}
                      style={{ whiteSpace: 'nowrap' }}
                    ></McTab>
                    <div slot="panel"></div>
                  </McTabBar>
                </div>
              </div>

              {/* Platform Selection (only shown when platform view is selected) */}
              {viewType === "platforms" && (
                <div className="content-lp-item" style={{ marginBottom: 20 }}>
                  <div style={{ marginBottom: 20 }}>
                    {edit
                    ? "This is a comprehensive overview of the Changes occurring in the platform you are a part of."
                    : `This is a comprehensive overview of the Changes occurring in the platform ${inputNameValue1} is a part of.`}
                  </div>
                  <Box sx={{ textAlign: "center", position: "relative" }} ref={platformDropdownRef}>
                    {userDetails.platforms.length > 1 ? (
                      <>
                        <Typography
                          variant="body1"
                          sx={{
                            fontWeight: "600",
                            color: "#333",
                            display: "inline-flex",
                            alignItems: "center",
                            cursor: "pointer",
                            fontSize: '1rem',
                            fontFamily: maerskFontFamily
                          }}
                          onClick={handlePlatformDropdownToggle}
                        >
                          {selectedPlatform || "Select a platform"}
                          {platformDropdownOpen ? (
                            <KeyboardArrowUpIcon fontSize="small" sx={{ ml: 0.5 }} />
                          ) : (
                            <KeyboardArrowDownIcon fontSize="small" sx={{ ml: 0.5 }} />
                          )}
                        </Typography>
                        {platformDropdownOpen && (
                          <Box
                            sx={{
                              position: "absolute",
                              left: "50%",
                              transform: "translateX(-50%)",
                              top: "100%",
                              mt: 1,
                              bgcolor: "white",
                              boxShadow: 3,
                              borderRadius: 1,
                              zIndex: 5000,
                              minWidth: 300,
                              maxHeight: 200,
                              overflowY: "auto",
                              p: 1,
                              fontFamily: maerskFontFamily
                            }}
                            onClick={(e) => e.stopPropagation()}
                          >
                            {userDetails.platforms.map((platform, index) => (
                              <Typography
                                key={index}
                                // variant="body2"
                                sx={{
                                  px: 1,
                                  py: 0.5,
                                  color: platform === selectedPlatform ? "#aaa" : "#333",
                                  cursor: platform === selectedPlatform ? "not-allowed" : "pointer",
                                  "&:hover": platform === selectedPlatform ? {} : { bgcolor: "#f0f0f0" },
                                  opacity: platform === selectedPlatform ? 0.6 : 1,
                                  textAlign: "left",
                                  fontFamily: maerskFontFamily
                                }}
                                onClick={() => {
                                  if (platform !== selectedPlatform) {
                                    handlePlatformChange(platform);
                                    setPlatformDropdownOpen(false);
                                  }
                                }}
                              >
                                {platform}
                              </Typography>
                            ))}
                          </Box>
                        )}
                      </>
                    ) : (
                      <Typography
                        variant="body1"
                        sx={{
                          fontWeight: "600",
                          color: "#333",
                          fontSize: '1rem',
                          fontFamily: maerskFontFamily
                        }}
                      >
                        {selectedPlatform || userDetails.platforms[0] || "No platform available"}
                      </Typography>
                    )}
                  </Box>
                </div>
              )}

              {/* Portfolio Selection (only shown when portfolio view is selected) */}
              {viewType === "portfolios" && (
                <div className="content-lp-item" style={{ marginBottom: 20 }}>
                  <div style={{ marginBottom: 20 }}>
                    {edit
                    ? "This is a comprehensive overview of the Changes occurring in the portfolio you are a part of."
                    : `This is a comprehensive overview of the Changes occurring in the portfolio ${inputNameValue1} is a part of.`}
                  </div>
                  <Box sx={{ textAlign: "center", position: "relative" }} ref={portfolioDropdownRef}>
                    {userDetails.portfolios.length > 1 ? (
                      <>
                        <Typography
                          variant="body1"
                          sx={{
                            fontWeight: "600",
                            color: "#333",
                            display: "inline-flex",
                            alignItems: "center",
                            cursor: "pointer",
                            fontSize: '1rem',
                            fontFamily: maerskFontFamily
                          }}
                          onClick={handlePortfolioDropdownToggle}
                        >
                          {selectedPortfolio || "Select a portfolio"}
                          {portfolioDropdownOpen ? (
                            <KeyboardArrowUpIcon fontSize="small" sx={{ ml: 0.5 }} />
                          ) : (
                            <KeyboardArrowDownIcon fontSize="small" sx={{ ml: 0.5 }} />
                          )}
                        </Typography>
                        {portfolioDropdownOpen && (
                          <Box
                            sx={{
                              position: "absolute",
                              left: "50%",
                              transform: "translateX(-50%)",
                              top: "100%",
                              mt: 1,
                              bgcolor: "white",
                              boxShadow: 3,
                              borderRadius: 1,
                              zIndex: 5000,
                              minWidth: 300,
                              maxHeight: 200,
                              overflowY: "auto",
                              p: 1,
                              fontFamily: maerskFontFamily
                            }}
                            onClick={(e) => e.stopPropagation()}
                          >
                            {userDetails.portfolios.map((portfolio, index) => (
                              <Typography
                                key={index}
                                // variant="body2"
                                sx={{
                                  px: 1,
                                  py: 0.5,
                                  color: portfolio === selectedPortfolio ? "#aaa" : "#333",
                                  cursor: portfolio === selectedPortfolio ? "not-allowed" : "pointer",
                                  "&:hover": portfolio === selectedPortfolio ? {} : { bgcolor: "#f0f0f0" },
                                  opacity: portfolio === selectedPortfolio ? 0.6 : 1,
                                  textAlign: "left",
                                  fontFamily: maerskFontFamily
                                }}
                                onClick={() => {
                                  if (portfolio !== selectedPortfolio) {
                                    handlePortfolioChange(portfolio);
                                    setPortfolioDropdownOpen(false);
                                  }
                                }}
                              >
                                {portfolio}
                              </Typography>
                            ))}
                          </Box>
                        )}
                      </>
                    ) : (
                      <Typography
                        variant="body1"
                        sx={{
                          fontWeight: "600",
                          color: "#333",
                          fontSize: '1rem',
                          fontFamily: maerskFontFamily
                        }}
                      >
                        {selectedPortfolio || userDetails.portfolios[0] || "No portfolio available"}
                      </Typography>
                    )}
                  </Box>
                </div>
              )}

              {viewType === "applications" && (
                <div className="content-lp-item" style={{ marginBottom: 20 }}>
                  <div>
                  {userDetails.applicationsCount === 0 ? (
                    edit 
                      ? "No applications found for you."
                      : `No applications found for ${inputNameValue1 || "user"}.`
                  ) : (
                    edit
                      ? "This is a comprehensive overview of the Changes occurring on all the applications you own along with their upstream dependencies."
                      : `This is a comprehensive overview of the Changes occurring on all the applications ${inputNameValue1} owns along with their upstream dependencies.`
                  )}
                  </div>
                </div>
              )}

              {/* Only show charts, time filter, and table if applications count > 0 when in applications view */}
              {!(viewType === "applications" && userDetails.applicationsCount === 0) && (
                <>
                  {(isLoadingPortfolioData || isLoadingPlatformData) ? (
                    <Box sx={{ 
                      display: 'flex', 
                      justifyContent: 'center', 
                      alignItems: 'center',
                      width: '100%',
                      marginTop: "50px"
                    }}>
                      <CircularProgress />
                    </Box>
                  ) : (
                    <>
                      {/* Charts Section - Card Based Layout */}
                      <div className="content-lp-item" style={{ marginBottom: '15px' }}>
                        <div
                          style={{
                            marginTop: "0px",
                            marginLeft: "40px",
                            marginRight: "40px"
                          }}
                        >
                      <Box 
                        sx={{ 
                          display: 'flex', 
                          flexWrap: 'wrap', 
                          gap: 2, 
                          justifyContent: 'center', 
                          marginBottom: "40px" 
                        }}
                      >
                        <Box sx={{ flex: '1' }}>
                          <LandingPageInsights
                            title="Change Success Rate"
                            data={successRateData}
                            total={successRate.total}
                            cardLoading={isLoadingData}
                            onNumberClick={handleChangesDrawerOpen}
                            colors={COLORS}
                          />
                        </Box>
                        <Box sx={{ flex: '1' }}>
                          <LandingPageInsights
                            title="Overdue Changes"
                            data={overdueData}
                            total={overdueChanges.total}
                            cardLoading={isLoadingData}
                            onNumberClick={handleChangesDrawerOpen}
                            colors={COLORS}
                          />
                        </Box>
                        <Box sx={{ flex: '1' }}>
                          <LandingPageInsights
                            title="Conflicting Changes"
                            data={conflictData}
                            total={conflictingChanges.total}
                            cardLoading={isLoadingData}
                            onNumberClick={handleChangesDrawerOpen}
                            colors={COLORS}
                          />
                        </Box>
                        <Box sx={{ flex: '1' }}>
                          <LandingPageInsights
                            title="Incidents due to Changes"
                            data={incidentsChartData}
                            total={incidentsData.total}
                            cardLoading={isLoadingData}
                            onNumberClick={handleIncidentsDrawerOpen}
                            colors={COLORS}
                          />
                        </Box>
                      </Box>
                    </div>
                  </div>

                  {/* Time Filter Dropdown Section */}
                  <div className="content-lp-item" style={{ marginBottom: 0 }}>
                    <Box sx={{ textAlign: "center", position: "relative" }} ref={timeFilterDropdownRef}>
                      <Typography
                        variant="body1"
                        sx={{
                          fontWeight: "600",
                          color: "#333",
                          display: "inline-flex",
                          alignItems: "center",
                          cursor: "pointer",
                          fontSize: '1.2rem',
                          fontFamily: maerskFontFamily
                        }}
                        onClick={handleTimeFilterDropdownToggle}
                      >
                        {timeFilter.charAt(0).toUpperCase() + timeFilter.slice(1)} Changes
                        {timeFilterDropdownOpen ? (
                          <KeyboardArrowUpIcon fontSize="small" sx={{ ml: 0.5 }} />
                        ) : (
                          <KeyboardArrowDownIcon fontSize="small" sx={{ ml: 0.5 }} />
                        )}
                      </Typography>
                      {timeFilterDropdownOpen && (
                        <Box
                          sx={{
                            position: "absolute",
                            left: "50%",
                            transform: "translateX(-50%)",
                            top: "100%",
                            mt: 1,
                            bgcolor: "white",
                            boxShadow: 3,
                            borderRadius: 1,
                            zIndex: 5000,
                            minWidth: 140,
                            maxHeight: 150,
                            overflowY: "auto",
                            p: 1,
                            fontFamily: maerskFontFamily
                          }}
                          onClick={(e) => e.stopPropagation()}
                        >
                          {['ongoing', 'past', 'future'].map((filter) => (
                            <Typography
                              key={filter}
                            //   variant="body2"
                              sx={{
                                px: 1,
                                py: 0.5,
                                color: filter === timeFilter ? "#aaa" : "#333",
                                cursor: filter === timeFilter ? "not-allowed" : "pointer",
                                "&:hover": filter === timeFilter ? {} : { bgcolor: "#f0f0f0" },
                                opacity: filter === timeFilter ? 0.6 : 1,
                                textTransform: 'capitalize',
                                fontFamily: maerskFontFamily
                              }}
                              onClick={() => {
                                if (filter !== timeFilter) {
                                  handleTimeFilterChange(filter);
                                }
                              }}
                              disabled={filter === timeFilter}
                            >
                              {filter} Changes
                            </Typography>
                          ))}
                        </Box>
                      )}
                    </Box>
                  </div>

                  {/* Table Section */}
                  <div className="content-lp-item">
                  <LandingPageTable
                      data={tableDataForDisplay}
                      Header1="Change Number"
                      Header2="Configuration Item"
                      Header3="Risk"
                      Header4="Short Description"
                      Header5="Planned Start Date"
                      Header6="Planned End Date"
                      Header7="State"
                      Header8="Type"
                      Header9="Assignment Group"
                      Header10="Requested By"
                      Header11="Close Code"
                      setisdrawerOpen={setisdrawerOpen}
                      setDrawerCi={setDrawerCi}
                      setDrawerCiCategory={setDrawerCiCategory}
                      setDrawerType={setDrawerType}
                      setDrawerChange={setDrawerChange}
                      isLoading={isLoadingData}
                  />
                  </div>
                    </>
                  )}
                </>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default LandingPage;
